import { render, staticRenderFns } from "./ClearDBModal.vue?vue&type=template&id=0143bc14&scoped=true&"
import script from "./ClearDBModal.vue?vue&type=script&lang=js&"
export * from "./ClearDBModal.vue?vue&type=script&lang=js&"
import style0 from "./ClearDBModal.vue?vue&type=style&index=0&id=0143bc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143bc14",
  null
  
)

export default component.exports